module.exports = __webpack_public_path__ + "img/Jump Casting96.e027826b.jpg";